export default "__VITE_ASSET__B_oAmT4h__"